import { render, staticRenderFns } from "./SecondCuadro.vue?vue&type=template&id=9a3420f0&"
import script from "./SecondCuadro.vue?vue&type=script&lang=js&"
export * from "./SecondCuadro.vue?vue&type=script&lang=js&"
import style0 from "./SecondCuadro.vue?vue&type=style&index=0&id=9a3420f0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports